// extracted by mini-css-extract-plugin
module.exports = {"root":"authPick_root__CnIRB","wrapper":"authPick_wrapper__3fcCJ","head":"authPick_head__3sd5C","subHead":"authPick_subHead__2HGaM","btn":"authPick_btn__3R7FS"};